<div class="container mt-2">
  <app-about-me></app-about-me>
  <div class="row">
    <div class="col-md-12">
      <app-skills></app-skills>
    </div>
  </div>
  <div class="row" id="skills">
    <div class="col-md-12">
      <app-technical-skills></app-technical-skills>
    </div>
  </div>
  <div class="row" id="experience">
    <div class="col-md-12">
      <app-timeline></app-timeline>
    </div>
  </div>
  <div class="row" id="projects">
    <div class="col-md-12">
      <app-projects></app-projects>
    </div>
  </div>
  <div class="row" id="certificates">
    <div class="col-md-12">
      <app-certificates></app-certificates>
    </div>
  </div>
  <div class="row" id="interests">
    <div class="col-md-12">
      <app-areas-of-interest></app-areas-of-interest>
    </div>
  </div>
  <div class="row" id="contact">
    <div class="col-md-12">
      <app-contact></app-contact>
    </div>
  </div>
</div>
